import Vue from 'vue'
import VueResource from 'vue-resource'
import datePicker from '../../component/dccore-form/datePicker.vue'
import moment from 'moment'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import RoutesGrouped from './RoutesGrouped.vue'
import bootbox from 'bootbox';

require('bootstrap');

window.assignPopup = (val) => {
  const assignData = $('#assign-data');
  const gridSelector = assignData.attr('data-grid-selector');
  if (val == 1) {
    document.querySelector('.grid_massactions select').value = 0;
    window.assingDataCount = assignData.attr('data-count');
  } else {
    window.assingDataCount = $('input.action:checked').length;
  }
  window.assignDataFilters = assignData.html();
  window.assingDataDate = assignData.attr('data-date');

  document.querySelector(gridSelector + '_mass_action_all').value = val;
};

if ($('#route-sorter').length) {
  const spinner = '<p><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></p>';

  window.assingLoading = (event) => {
    window.assignDialog.find('.bootbox-body').html(spinner);
    // const hash = $('[data-grid-hash]').data('gridHash');
    // eval(hash + "_submitForm(event,$('#" + hash + "'))");
    // $($('[data-grid-selector]').attr('data-grid-selector')).submit();
    $($('[data-grid-selector]').attr('data-grid-selector')).submit();
  };

  $(function () {
    setTimeout(function () {
      $('.alert.alert-success').remove();
    }, 3000);

    $('body').on('click', '.data-url', function () {
      if (document.querySelector('.grid_massactions select').value != 0) {
        return;
      }
      let url = $(this).data('url');
      let dialog = bootbox.dialog({
        title: $(this).data('title'),
        message: spinner,
        backdrop: true,
        onEscape: true,
        className: 'assign-modal',
        size: 'md',
      });

      window.assignDialog = dialog;
      dialog.init(function () {
        $.ajax({
          url: url,
          type: 'GET',
          success: function (result) {
            dialog.find('.bootbox-body').html(result);
            $('#assignDataFiltersId').html(window.assignDataFilters);
            $('#assingDataCountId').html(window.assingDataCount);
            $('#assingDataDate').html(window.assingDataDate);
          },
          error: function () {
            console.log('Error');
          }
        });
      });
    });
  });

  Vue.use(VueResource);
  new Vue({
    el: '#route-sorter',
    components: {
      datePicker
    }
  });
}

if ($('#assign_route_to_sorter').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#assign_route_to_sorter',
    components: {
      datePicker,
      RingLoader,
      RoutesGrouped
    },
    data: {
      loading: 0,
      deliveryDate: moment().locale('pl').format('YYYY-MM-DD'),
      unassigned: [],
      assigned: {},
    },
    methods: {
      getRoutes() {
        this.loading++
        this.resetData()
        let url = Routing.generate('api_get_routes_with_bags_for_day', { day: this.deliveryDate })
        this.$http.get(url).then(response => {
          response.data.forEach(route => {
            if (!route.sorter_id) {
              this.unassigned.push(route)
            } else {
              if (!this.assigned.hasOwnProperty(route.sorter_id)) {
                this.assigned[route.sorter_id] = []
              }
              this.assigned[route.sorter_id].push(route)
            }
          })
          this.loading--
        })
      },
      assign(sorter) {
        this.loading++
        let data = {
          date: this.deliveryDate,
          routes: $('.routes_to_assign_checkbox:checked').map((i, route) => $(route).attr('data-id')).toArray()
        }

        let url = Routing.generate('api_post_assign_sorter_to_routes', { sorter })
        this.$http.post(url, data).then(() => {
          this.getRoutes()
          this.loading--
        })
      },
      resetData() {
        this.unassigned = []
        this.assigned = {}
      },
      checkSorterRoutes(sorter) {
        $(`.routes_sorter_${sorter}:not(:disabled)`).prop('checked', true)
      },
      clearSorter() {
        this.loading++
        let data = {
          date: this.deliveryDate,
          routes: $('.routes_sorter_1:checked, .routes_sorter_2:checked').map((i, route) => $(route).attr('data-id')).toArray()
        }

        let url = Routing.generate('api_post_clear_sorter_on_routes')
        this.$http.post(url, data).then(() => {
          this.getRoutes()
          this.loading--
        })
      }
    },
  })
}
